import { render, staticRenderFns } from "./AppHeader_Navs.vue?vue&type=template&id=c145fc3e&scoped=true&"
import script from "./AppHeader_Navs.vue?vue&type=script&lang=js&"
export * from "./AppHeader_Navs.vue?vue&type=script&lang=js&"
import style0 from "./AppHeader_Navs.vue?vue&type=style&index=0&id=c145fc3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c145fc3e",
  null
  
)

export default component.exports